import { useBaseViewModel } from '@/common';
import { OperationMethodTable } from '@/domains/operation-methods/entities';
import { FindAllOperationMethodUsecase } from '@/domains/operation-methods/usecases';
import { useState } from 'react';
import { QueryOperationMethodPayload } from '@/domains/operation-methods/ports/payloads';
import { OperationMethodHttpRepository } from '../adapters/repositories';

export default function GetListOperationMethod() {
  const findAllOperationMethodUC = new FindAllOperationMethodUsecase(
    new OperationMethodHttpRepository(),
  );
  const { loading, error, catchAction } = useBaseViewModel();
  const [operationMethodData, setOperationMethodData] = useState<OperationMethodTable[]>([]);

  const actionGetAllOperationMethod = async (payload?: QueryOperationMethodPayload) => {
    await catchAction(async () => {
      const data = await findAllOperationMethodUC.run(payload);
      setOperationMethodData(data);
    });
  };

  return {
    loading,
    error,
    operationMethodData,
    actionGetAllOperationMethod,
  };
}
